<script lang="ts" setup="">
import AppButton from '~/components/ui/buttons/AppButton.vue'
import AppInput from '~/components/ui/form/formElements/AppInput.vue'
import AppCheckbox from '~/components/ui/form/formElements/AppCheckbox.vue'
import apiConfig from '~/shared/config/api'
import customFetch from '~/composables/custom-fetch'
import useMainStore from '~/shared/store'
import type {IInput} from '~/shared/interfaces/ui/form/formInputs'

const emits = defineEmits(['send-form'])
const mainStore = useMainStore()
const {bitrix} = apiConfig
const isSubmitDisabled = ref(true)
const isFormSend = ref(false)
const policyCheck = ref(false)
const privacyTxt = `Я согласен с <a href="/privacy" target="_blank" rel="noopener noreferrer">условиями обработки персональных данных</a>`

const formState = ref<{phone: string, fio: string}>({
  phone: '',
  fio: '',
})

const formConfig: IInput[] = [
  {
    inputConfig: {
      id: 'phone',
      label: 'Телефон',
      interactiveLabel: true,
      maskType: 'phone',
    },
    validatorConfig: {
      required: true,
      phoneFormat: true,
    }
  },
  {
    inputConfig: {
      id: 'fio',
      label: 'ФИО',
      interactiveLabel: true,
    },
    validatorConfig: {
      required: true,
    }
  }
]

function handleData(e: CustomEvent) {
  !e.errorInfo.hasError ?
    formState.value[e.id] = e.value :
    formState.value[e.id] = ''
}

async function sendForm() {
  isSubmitDisabled.value = true
  const res = await customFetch(bitrix.sendWidgetForm(formState.value))
  if (res.success) {
    mainStore.setBitrixModalState(false)
    isFormSend.value = true
    setTimeout(() => isFormSend.value = false, 60000)
  }
}

watch(formState, () => {
  isSubmitDisabled.value = formState.value.phone && formState.value.fio && !isFormSend
}, {deep: true})
</script>

<template>
  <form class="widget-form" @submit.prevent>
    <div class="widget-form__fields">
      <AppInput
        :input-config="formConfig[0].inputConfig"
        :validator-settings="formConfig[0].validatorConfig"
        @get-data="handleData"
      />
      <AppInput
        :input-config="formConfig[1].inputConfig"
        :validator-settings="formConfig[1].validatorConfig"
        @get-data="handleData"
      />
    </div>
    <div class="widget-form__check">
      <AppCheckbox
        checkbox-id="useTerms"
        :checkbox-label="privacyTxt"
        v-model="policyCheck"
        checkbox-label-distance="big-distance"
      />
    </div>
    <AppButton
      text="Оставить заявку"
      :is-disabled="isSubmitDisabled || !policyCheck"
      @click="sendForm"
    />
  </form>
</template>

<style lang="scss" scoped>
.widget-form {
  &__fields {
    display: flex;
    gap: 16px;
    margin: 28px 0 16px;

    @include xs-breakpoint {
      flex-direction: column;
    }
  }

  &__check {
    margin: 16px 0 28px;

    .checkbox {
      justify-content: flex-end;
      :deep(a) {
        color: $control-content_primary;
        text-decoration: underline;
      }

      :deep(.checkbox-text) {
        margin-top: 1px;
      }
    }
  }
}
</style>
